import React, { Component } from 'react';
import './header.css'

class Header extends Component {
    render() {
        return (
                <section class="category_banner">>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 category_bannertext">
                                <h1>Our Methodology</h1>
                                <p>We collate data from various publications and triangulate the collected data using multiple verification points. Our in-house and external experts validate the data of every project, and we validate the data with our existing repository to study the market, garner insights and visualize the entire ecosystem.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/consulting/OurMethodology/header/header.js